module.exports = __webpack_public_path__ + "static/WEDDING E&M-414-8f79d2492c368328163016c82a5b847d.jpg";